import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button, Row, Col, Table, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { puede } from "../../../../permisos/permisos";

// Ordenes de produccion: que se va a producir; la produccion registrada abona a la orden.
function ListadoOrdenesProduccion() {
  const { user } = useContext(AuthContext);
  const URL_ORDENES_PRODUCCION = process.env.REACT_APP_URL_ORDENES_PRODUCCION;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_MOLDES = process.env.REACT_APP_URL_MOLDES_INYECCION;
  const URL_MAQUINAS = process.env.REACT_APP_URL_MAQUINAS;
  const URL_MOLDES_SOPLADO = process.env.REACT_APP_URL_MOLDES_SOPLADO;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [ordenes, setOrdenes] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [moldes, setMoldes] = useState([]);
  const [maquinas, setMaquinas] = useState([]);
  const [moldesSoplado, setMoldesSoplado] = useState([]);
  const [filtroEstado, setFiltroEstado] = useState("Abierta");

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState(null);

  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [articulo, setArticulo] = useState("");
  const [color, setColor] = useState("");
  const [coloresCat, setColoresCat] = useState([]);
  const [moldeInyeccion, setMoldeInyeccion] = useState("");
  const [maquina, setMaquina] = useState("");
  const [moldeSoplado, setMoldeSoplado] = useState("");
  const [cavidades, setCavidades] = useState(0);
  const [cantidadPlaneada, setCantidadPlaneada] = useState(0);
  const [observaciones, setObservaciones] = useState("");

  useEffect(() => {
    getOrdenes();
    axios.get(URL_ARTICULOS, headers).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(URL_MOLDES, headers).then((r) => setMoldes(r.data)).catch((e) => console.log(e));
    axios
      .get(URL_MAQUINAS, headers)
      .then((r) => setMaquinas(r.data.sort((x, y) => x.nombre.localeCompare(y.nombre, "es", { numeric: true }))))
      .catch((e) => console.log(e));
    axios.get(URL_MOLDES_SOPLADO, headers).then((r) => setMoldesSoplado(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_COLORES, headers).then((r) => setColoresCat(r.data)).catch((e) => console.log(e));
  }, []);

  function getOrdenes() {
    axios
      .get(URL_ORDENES_PRODUCCION, headers)
      .then((r) => setOrdenes(r.data || []))
      .catch((e) => console.log(e));
  }

  function abreNuevo() {
    setIdEdit(null);
    setFecha(moment().format("YYYY-MM-DD"));
    setArticulo(""); setColor(""); setMoldeInyeccion(""); setMaquina(""); setMoldeSoplado(""); setCavidades(0);
    setCantidadPlaneada(0); setObservaciones("");
    toggle();
  }

  function abreEdit(o) {
    setIdEdit(o._id);
    setFecha(o.fecha || moment().format("YYYY-MM-DD"));
    setArticulo(o.articulo ? (o.articulo._id || o.articulo) : "");
    setColor(o.color ? (o.color._id || o.color) : "");
    setMoldeInyeccion(o.moldeInyeccion ? (o.moldeInyeccion._id || o.moldeInyeccion) : "");
    setMaquina(o.maquina ? (o.maquina._id || o.maquina) : "");
    setMoldeSoplado(o.moldeSoplado ? (o.moldeSoplado._id || o.moldeSoplado) : "");
    setCavidades(o.cavidades || 0);
    setCantidadPlaneada(o.cantidadPlaneada || 0);
    setObservaciones(o.observaciones === "NA" ? "" : (o.observaciones || ""));
    toggle();
  }

  function cambiaArticulo(id) {
    setArticulo(id);
  }

  // ---- Cascada: maquina -> molde de inyeccion compatible -> molde de soplado compatible -> cavidades
  const idDe = (x) => (x && x._id ? x._id : x);
  const montaEn = (molde, idMaq) => (molde.maquinas || []).some((m) => idDe(m) === idMaq);
  // Inyeccion: los que se montan en la maquina elegida.
  const inyeccionCompatibles = maquina ? moldes.filter((m) => montaEn(m, maquina)) : moldes;
  // Soplado: los de la maquina y, si hay molde de inyeccion, los que usan su preforma.
  // Sin molde de inyeccion (sopladoras M8/APF) salen los que no dependen de uno.
  const sopladoCompatibles = moldesSoplado.filter(
    (s) =>
      (!maquina || montaEn(s, maquina)) &&
      (moldeInyeccion ? idDe(s.moldeInyeccion) === moldeInyeccion : !s.moldeInyeccion || !maquina)
  );

  function eligeMaquina(id) {
    setMaquina(id);
    const iny = moldes.find((m) => m._id === moldeInyeccion);
    const sigueIny = iny && (!id || montaEn(iny, id));
    if (!sigueIny) setMoldeInyeccion("");
    const sop = moldesSoplado.find((x) => x._id === moldeSoplado);
    if (!sop || (id && !montaEn(sop, id)) || !sigueIny) {
      setMoldeSoplado("");
      setCavidades(sigueIny && iny ? iny.cavidades || 0 : 0);
    }
  }
  function eligeInyeccion(id) {
    setMoldeInyeccion(id);
    setMoldeSoplado("");
    const iny = moldes.find((m) => m._id === id);
    setCavidades(iny ? iny.cavidades || 0 : 0);
  }
  function eligeSoplado(id) {
    setMoldeSoplado(id);
    const sop = moldesSoplado.find((x) => x._id === id);
    if (sop) setCavidades(sop.cavidades || 0);
  }

  function guardar() {
    if (!articulo || Number(cantidadPlaneada) <= 0) {
      Swal.fire("Atención", "Selecciona el artículo y captura la cantidad a producir", "warning");
      return;
    }
    const body = {
      fecha,
      articulo,
      color: color || null,
      moldeInyeccion: moldeInyeccion || null,
      maquina: maquina || null,
      moldeSoplado: moldeSoplado || null,
      cavidades: Number(cavidades) || 0,
      cantidadPlaneada: Number(cantidadPlaneada),
      observaciones: observaciones || "NA",
    };
    const req = idEdit
      ? axios.patch(`${URL_ORDENES_PRODUCCION}/${idEdit}`, body, headers)
      : axios.post(URL_ORDENES_PRODUCCION, body, headers);
    req
      .then(() => {
        axios.post(URL_LOGS, { tipo: idEdit ? "Editar Orden Produccion" : "Crear Orden Produccion", detalle: `Cant ${cantidadPlaneada}`, user: user.id }, headers);
        toggle();
        Swal.fire("Good job!", idEdit ? "Orden actualizada" : "Orden creada", "success");
        window.location.reload();
      })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? JSON.stringify(error.response.data) : error}` }));
  }

  function cerrarOrden(o) {
    Swal.fire({
      title: "Cerrar orden?",
      html: `Producido <b>${o.producido}</b> de <b>${o.cantidadPlaneada}</b>. Ya no se podrá registrar producción contra esta orden.`,
      icon: "question", showCancelButton: true, confirmButtonText: "Sí, cerrar", cancelButtonText: "Cancelar",
    }).then((r) => {
      if (r.isConfirmed) {
        axios.patch(`${URL_ORDENES_PRODUCCION}Cerrar/${o._id}`, { fecha: moment().format("YYYY-MM-DD") }, headers)
          .then(() => {
            axios.post(URL_LOGS, { tipo: "Cerrar Orden Produccion", detalle: `Orden ${o.idOrdenProduccion}`, user: user.id }, headers);
            Swal.fire("Listo!", "Orden cerrada", "success");
            window.location.reload();
          })
          .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data.message || JSON.stringify(error.response.data) : error}` }));
      }
    });
  }

  function cancelarOrden(o) {
    Swal.fire({
      title: "Cancelar orden?",
      text: "Solo se puede cancelar si no tiene producción registrada.",
      icon: "warning", showCancelButton: true, confirmButtonText: "Sí, cancelar", cancelButtonText: "No",
    }).then((r) => {
      if (r.isConfirmed) {
        axios.patch(`${URL_ORDENES_PRODUCCION}Cancelar/${o._id}`, {}, headers)
          .then(() => {
            axios.post(URL_LOGS, { tipo: "Cancelar Orden Produccion", detalle: `Orden ${o.idOrdenProduccion}`, user: user.id }, headers);
            Swal.fire("Listo!", "Orden cancelada", "success");
            window.location.reload();
          })
          .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data.message || JSON.stringify(error.response.data) : error}` }));
      }
    });
  }

  function PDFOrden(o) {
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 12, 45, 15);
    doc.setFontSize(14);
    doc.text(`Orden de Producción # ${o.idOrdenProduccion}`, 14, 18);
    doc.setFontSize(11);
    doc.text(`Fecha: ${o.fecha}`, 14, 26);
    doc.text(`Estado: ${o.estado}`, 14, 32);
    doc.autoTable({
      head: [["Artículo", "Color", "Máquina", "Molde Iny.", "Molde Soplado", "Cav.", "Planeada", "Producido", "Pendiente"]],
      body: [[
        o.articulo ? o.articulo.descripcion : "-",
        o.color ? o.color.name : "-",
        o.maquina ? o.maquina.nombre : "-",
        o.moldeInyeccion ? o.moldeInyeccion.nombre : "-",
        o.moldeSoplado ? o.moldeSoplado.nombre : "-",
        o.cavidades || "-",
        o.cantidadPlaneada, o.producido, o.pendiente,
      ]],
      startY: 40,
    });
    doc.setFontSize(10);
    doc.text(`Observaciones: ${o.observaciones || ""}`, 14, doc.autoTable.previous.finalY + 10);
    window.open(doc.output("bloburl"), "_blank");
  }

  const badgeEstado = (e) => {
    const map = { Abierta: "success", Cerrada: "dark", Cancelada: "danger" };
    return <span className={`badge badge-${map[e] || "secondary"}`}>{e}</span>;
  };

  const dataFiltrada = ordenes.filter((o) => (!filtroEstado ? true : o.estado === filtroEstado));

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "produccion.ordenes.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-clipboard-list" style={{ marginRight: 8, color: "#0ea5e9" }} />
                  Órdenes de Producción
                </h3>
                <p className="page-subtitle">Planea la producción y registra lo que salió contra la orden</p>
              </div>
              <div className="page-actions">
                {puede(user, "produccion.ordenes.crear") && (
<Button size="sm" color="success" onClick={abreNuevo}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nueva Orden
                </Button>
)}
              </div>
            </div>
            <Row>
              <Col md={3}>
                <Label>Estado</Label>
                <Input bsSize="sm" type="select" value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                  <option value="">Todos</option>
                  <option value="Abierta">Abiertas</option>
                  <option value="Cerrada">Cerradas</option>
                  <option value="Cancelada">Canceladas</option>
                </Input>
              </Col>
            </Row>
            <br />
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Folio</th>
                  <th className="tituloTabla">Fecha</th>
                  <th className="tituloTabla">Artículo</th>
                  <th className="tituloTabla">Color</th>
                  <th className="tituloTabla">Molde Iny.</th>
                  <th className="tituloTabla">Máquina</th>
                  <th className="tituloTabla">Molde soplado</th>
                  <th className="tituloTabla">Cav.</th>
                  <th className="tituloTabla">Planeada</th>
                  <th className="tituloTabla">Producido</th>
                  <th className="tituloTabla">Pendiente</th>
                  <th className="tituloTabla">Estado</th>
                  <th className="tituloTabla">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {dataFiltrada.map((o) => (
                  <tr key={o._id}>
                    <td>{o.idOrdenProduccion}</td>
                    <td>{o.fecha}</td>
                    <td>{o.articulo ? o.articulo.descripcion : "-"}</td>
                    <td>{o.color ? o.color.name : "-"}</td>
                    <td>{o.moldeInyeccion ? o.moldeInyeccion.nombre : "-"}</td>
                    <td>{o.maquina ? o.maquina.nombre : "-"}</td>
                    <td>{o.moldeSoplado ? o.moldeSoplado.nombre : "-"}</td>
                    <td>{o.cavidades || "-"}</td>
                    <td>{Number(o.cantidadPlaneada || 0).toLocaleString("es-MX")}</td>
                    <td>{Number(o.producido || 0).toLocaleString("es-MX")}</td>
                    <td>{Number(o.pendiente || 0).toLocaleString("es-MX")}</td>
                    <td>{badgeEstado(o.estado)}</td>
                    <td>
                      <Button color="danger" size="sm" onClick={() => PDFOrden(o)} title="PDF" style={{ marginRight: 4 }}>
                        <i className="far fa-file-pdf"></i>
                      </Button>
                      {o.estado === "Abierta" && (
                        <>
                          {puede(user, "produccion.ordenes.editar") && (
<Button color="info" size="sm" onClick={() => abreEdit(o)} title="Editar" style={{ marginRight: 4 }}>
                            <i className="fas fa-edit"></i>
                          </Button>
)}
                          <Button color="dark" size="sm" onClick={() => cerrarOrden(o)} title="Cerrar orden" style={{ marginRight: 4 }}>
                            <i className="fas fa-lock"></i>
                          </Button>
                          {puede(user, "produccion.ordenes.cancelar") && (
<Button color="warning" size="sm" onClick={() => cancelarOrden(o)} title="Cancelar">
                            <i className="fas fa-ban"></i>
                          </Button>
)}
                        </>
                      )}
                    </td>
                  </tr>
                ))}
                {dataFiltrada.length === 0 && (
                  <tr><td colSpan={11} align="center">Sin órdenes</td></tr>
                )}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      <Modal size="md" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-clipboard-list" style={{ marginRight: 8, color: "#0ea5e9" }} />
          {idEdit ? "Editar" : "Nueva"} Orden de Producción
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Fecha</Label>
              <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>Cantidad a producir *</Label>
              <Input type="number" value={cantidadPlaneada} onChange={(e) => setCantidadPlaneada(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={7}>
              <Label>Artículo *</Label>
              <Input type="select" value={articulo} onChange={(e) => cambiaArticulo(e.target.value)}>
                <option value="">Selecciona artículo...</option>
                {articulos
                  .filter((a) => a.is_active === "Si" && (a.tipo_articulo || "Fabricacion") === "Fabricacion")
                  .map((a) => (
                    <option key={a._id} value={a._id}>{a.descripcion}</option>
                  ))}
              </Input>
            </Col>
            <Col md={5}>
              <Label>Color</Label>
              <Input type="select" value={color} onChange={(e) => setColor(e.target.value)}>
                <option value="">Sin color</option>
                {(() => {
                  const art = articulos.find((a) => a._id === articulo);
                  const lista = (art && art.colores) || [];
                  return lista
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((c) => <option key={c._id} value={c._id}>{c.name}</option>);
                })()}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>1. Máquina</Label>
              <Input type="select" value={maquina} onChange={(e) => eligeMaquina(e.target.value)}>
                <option value="">Selecciona máquina...</option>
                {maquinas.map((m) => (
                  <option key={m._id} value={m._id}>{m.nombre}</option>
                ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>2. Molde de inyección</Label>
              <Input type="select" value={moldeInyeccion} disabled={!maquina} onChange={(e) => eligeInyeccion(e.target.value)}>
                <option value="">{inyeccionCompatibles.length ? "Selecciona..." : "Sin molde de inyección (sopladora)"}</option>
                {inyeccionCompatibles.map((m) => (
                  <option key={m._id} value={m._id}>{m.nombre}</option>
                ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={8}>
              <Label>3. Molde de soplado</Label>
              <Input type="select" value={moldeSoplado} disabled={!maquina} onChange={(e) => eligeSoplado(e.target.value)}>
                <option value="">{sopladoCompatibles.length ? "Selecciona..." : "No hay moldes de soplado compatibles"}</option>
                {sopladoCompatibles
                  .slice()
                  .sort((a, b) => b.mililitros - a.mililitros)
                  .map((m) => (
                    <option key={m._id} value={m._id}>
                      {m.nombre} — {m.cavidades} cav{m.ciclo ? `, ciclo ${m.ciclo}s` : ""}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={4}>
              <Label>4. Cavidades</Label>
              <Input type="number" min={0} value={cavidades} onChange={(e) => setCavidades(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Label>Observaciones</Label>
          <Input type="textarea" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}>Guardar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoOrdenesProduccion;
